import React from "react";
import {BLOCK_TYPE} from "draftail";

export default function SizePopoverOptions(props) {

    const option = (label, value) => {
        const classes = Classes("option", {selected: props.menuParams.value === value});

        return (
            <div className={classes} onClick={()=>{props.hidePopover(); props.menuParams.onChangeStyle(value)}}>
                <div className="label">{label}</div>
            </div>
        )
    }

    return (
        <div className="ui5-popover-menu" style={{minWidth:180}}>
            {option('Normal text', BLOCK_TYPE.UNSTYLED)}
            {option('Header 1',    BLOCK_TYPE.HEADER_ONE)}
            {option('Header 2',    BLOCK_TYPE.HEADER_TWO)}
            {option('Header 3',    BLOCK_TYPE.HEADER_THREE)}
        </div>
    );
}